// This file is AUTOGENERATED, do not edit it manually!!!

import { messageBoard as messageBoardde } from './messageBoardResx.de';
import { messageBoard as messageBoarden } from './messageBoardResx.en';
import { messageBoard as messageBoarden_risk } from './messageBoardResx.en_risk';
import { messageBoard as messageBoardes } from './messageBoardResx.es';
import { messageBoard as messageBoardfr } from './messageBoardResx.fr';
import { messageBoard as messageBoardit } from './messageBoardResx.it';
import { messageBoard as messageBoardnl } from './messageBoardResx.nl';
import { messageBoard as messageBoardpl } from './messageBoardResx.pl';
import { messageBoard as messageBoardpt } from './messageBoardResx.pt';
import { messageBoard as messageBoardru } from './messageBoardResx.ru';
import { messageBoard as messageBoardsk } from './messageBoardResx.sk';
import { messageBoard as messageBoardsv } from './messageBoardResx.sv';
import { messageBoard as messageBoardtr } from './messageBoardResx.tr';

const langMap: { [k: string]: Partial<typeof messageBoarden> } = {
    de: messageBoardde,
    en: messageBoarden,
    en_risk: messageBoarden_risk,
    es: messageBoardes,
    fr: messageBoardfr,
    it: messageBoardit,
    nl: messageBoardnl,
    pl: messageBoardpl,
    pt: messageBoardpt,
    ru: messageBoardru,
    sk: messageBoardsk,
    sv: messageBoardsv,
    tr: messageBoardtr,
};

/* tslint:disable: max-line-length */
export const messageBoardResx = {
    /**
    * en: Add message
    */
    get add_message_button() {
        return langMap[ep.resxCulture].add_message_button || langMap.en.add_message_button;
    },
    /**
    * en: Additional Recipients
    */
    get AdditionalRecipients() {
        return langMap[ep.resxCulture].AdditionalRecipients || langMap.en.AdditionalRecipients;
    },
    /**
    * en: Start typing to activate AI commands
    */
    get Ai_disabled_button() {
        return langMap[ep.resxCulture].Ai_disabled_button || langMap.en.Ai_disabled_button;
    },
    /**
    * en: Append
    */
    get Append() {
        return langMap[ep.resxCulture].Append || langMap.en.Append;
    },
    /**
    * en: Apply
    */
    get Apply() {
        return langMap[ep.resxCulture].Apply || langMap.en.Apply;
    },
    /**
    * en: approved with a message
    */
    get approval_request_approved_comment() {
        return langMap[ep.resxCulture].approval_request_approved_comment || langMap.en.approval_request_approved_comment;
    },
    /**
    * en: approval request
    */
    get approval_request_link() {
        return langMap[ep.resxCulture].approval_request_link || langMap.en.approval_request_link;
    },
    /**
    * en: rejected with a message
    */
    get approval_request_reject_comment() {
        return langMap[ep.resxCulture].approval_request_reject_comment || langMap.en.approval_request_reject_comment;
    },
    /**
    * en: Approve
    */
    get Approve() {
        return langMap[ep.resxCulture].Approve || langMap.en.Approve;
    },
    /**
    * en: approved
    */
    get Approver_Approved() {
        return langMap[ep.resxCulture].Approver_Approved || langMap.en.Approver_Approved;
    },
    /**
    * en: unread
    */
    get Approver_HasNotSeen() {
        return langMap[ep.resxCulture].Approver_HasNotSeen || langMap.en.Approver_HasNotSeen;
    },
    /**
    * en: no action
    */
    get Approver_NoAction() {
        return langMap[ep.resxCulture].Approver_NoAction || langMap.en.Approver_NoAction;
    },
    /**
    * en: viewed, approval pending
    */
    get Approver_NotApproved() {
        return langMap[ep.resxCulture].Approver_NotApproved || langMap.en.Approver_NotApproved;
    },
    /**
    * en: rejected
    */
    get Approver_Rejected() {
        return langMap[ep.resxCulture].Approver_Rejected || langMap.en.Approver_Rejected;
    },
    /**
    * en: Approvers
    */
    get ApproversGroupTitle() {
        return langMap[ep.resxCulture].ApproversGroupTitle || langMap.en.ApproversGroupTitle;
    },
    /**
    * en: File '{0}' has been removed.
    */
    get Attachment_Delete() {
        return langMap[ep.resxCulture].Attachment_Delete || langMap.en.Attachment_Delete;
    },
    /**
    * en: Based on notification rule
    */
    get BaseNotificationRule() {
        return langMap[ep.resxCulture].BaseNotificationRule || langMap.en.BaseNotificationRule;
    },
    /**
    * en: Your changes will be lost. Do you want to leave this page without save changes?
    */
    get BeforePageUnloadMessage() {
        return langMap[ep.resxCulture].BeforePageUnloadMessage || langMap.en.BeforePageUnloadMessage;
    },
    /**
    * en: Cancel
    */
    get Cancel() {
        return langMap[ep.resxCulture].Cancel || langMap.en.Cancel;
    },
    /**
    * en: Change tone
    */
    get ChangeTone() {
        return langMap[ep.resxCulture].ChangeTone || langMap.en.ChangeTone;
    },
    /**
    * en: Close
    */
    get Close() {
        return langMap[ep.resxCulture].Close || langMap.en.Close;
    },
    /**
    * en: Please contact your administrator
    */
    get ContactAdministrator() {
        return langMap[ep.resxCulture].ContactAdministrator || langMap.en.ContactAdministrator;
    },
    /**
    * en: Continue writing with AI
    */
    get ContinueWriting() {
        return langMap[ep.resxCulture].ContinueWriting || langMap.en.ContinueWriting;
    },
    /**
    * en: Delete
    */
    get Delete() {
        return langMap[ep.resxCulture].Delete || langMap.en.Delete;
    },
    /**
    * en: Are you sure you want to delete the attachment '{0}' ?
    */
    get DeleteAttachmentContentTemplate() {
        return langMap[ep.resxCulture].DeleteAttachmentContentTemplate || langMap.en.DeleteAttachmentContentTemplate;
    },
    /**
    * en: Delete attachment
    */
    get DeleteAttachmentTitle() {
        return langMap[ep.resxCulture].DeleteAttachmentTitle || langMap.en.DeleteAttachmentTitle;
    },
    /**
    * en: Discard
    */
    get Discard() {
        return langMap[ep.resxCulture].Discard || langMap.en.Discard;
    },
    /**
    * en: Download
    */
    get Download() {
        return langMap[ep.resxCulture].Download || langMap.en.Download;
    },
    /**
    * en: Drop files here
    */
    get DropHere() {
        return langMap[ep.resxCulture].DropHere || langMap.en.DropHere;
    },
    /**
    * en: Edit
    */
    get Edit() {
        return langMap[ep.resxCulture].Edit || langMap.en.Edit;
    },
    /**
    * en: Press ctrl + enter to <a apply>Apply</a> or esc to <a>Cancel</a>
    */
    get edit_actions() {
        return langMap[ep.resxCulture].edit_actions || langMap.en.edit_actions;
    },
    /**
    * en: This user will be notified only by email
    */
    get email_only_mention_title() {
        return langMap[ep.resxCulture].email_only_mention_title || langMap.en.email_only_mention_title;
    },
    /**
    * en: Error
    */
    get Error() {
        return langMap[ep.resxCulture].Error || langMap.en.Error;
    },
    /**
    * en: 1#{0} File#{0} Files
    */
    get FilePlural() {
        return langMap[ep.resxCulture].FilePlural || langMap.en.FilePlural;
    },
    /**
    * en: Error
    */
    get FileUploadError() {
        return langMap[ep.resxCulture].FileUploadError || langMap.en.FileUploadError;
    },
    /**
    * en: Version 
    */
    get FileVersion() {
        return langMap[ep.resxCulture].FileVersion || langMap.en.FileVersion;
    },
    /**
    * en: ver 
    */
    get FileVersionShort() {
        return langMap[ep.resxCulture].FileVersionShort || langMap.en.FileVersionShort;
    },
    /**
    * en: Formal
    */
    get Formal() {
        return langMap[ep.resxCulture].Formal || langMap.en.Formal;
    },
    /**
    * en: You have used {0} MB out of {1} MB.
    */
    get FreeSpaceTemplate() {
        return langMap[ep.resxCulture].FreeSpaceTemplate || langMap.en.FreeSpaceTemplate;
    },
    /**
    * en: Friendly
    */
    get Friendly() {
        return langMap[ep.resxCulture].Friendly || langMap.en.Friendly;
    },
    /**
    * en: Generated by AI...
    */
    get GeneratedByAi() {
        return langMap[ep.resxCulture].GeneratedByAi || langMap.en.GeneratedByAi;
    },
    /**
    * en: Hide files
    */
    get HideFiles() {
        return langMap[ep.resxCulture].HideFiles || langMap.en.HideFiles;
    },
    /**
    * en: Improve spelling and grammar
    */
    get ImproveSpelling() {
        return langMap[ep.resxCulture].ImproveSpelling || langMap.en.ImproveSpelling;
    },
    /**
    * en: Improve writing
    */
    get ImproveWriting() {
        return langMap[ep.resxCulture].ImproveWriting || langMap.en.ImproveWriting;
    },
    /**
    * en: Mention someone
    */
    get mention_title() {
        return langMap[ep.resxCulture].mention_title || langMap.en.mention_title;
    },
    /**
    * en: Message has been deleted.
    */
    get Message_Delete() {
        return langMap[ep.resxCulture].Message_Delete || langMap.en.Message_Delete;
    },
    /**
    * en: A message may contain up to 10 000 characters.
    */
    get message_maxLength_description() {
        return langMap[ep.resxCulture].message_maxLength_description || langMap.en.message_maxLength_description;
    },
    /**
    * en: The message is too long
    */
    get message_maxLength_title() {
        return langMap[ep.resxCulture].message_maxLength_title || langMap.en.message_maxLength_title;
    },
    /**
    * en: Delete this post?
    */
    get MessageDeleteConfirmation() {
        return langMap[ep.resxCulture].MessageDeleteConfirmation || langMap.en.MessageDeleteConfirmation;
    },
    /**
    * en: (edited)
    */
    get messageEdited() {
        return langMap[ep.resxCulture].messageEdited || langMap.en.messageEdited;
    },
    /**
    * en: Edited by 
    */
    get MessageEditedBy() {
        return langMap[ep.resxCulture].MessageEditedBy || langMap.en.MessageEditedBy;
    },
    /**
    * en: Add message, drop files or @mention someone
    */
    get messagePlaceholderText() {
        return langMap[ep.resxCulture].messagePlaceholderText || langMap.en.messagePlaceholderText;
    },
    /**
    * en: {0} of {1} {2}
    */
    get MultipleApproversTemplate() {
        return langMap[ep.resxCulture].MultipleApproversTemplate || langMap.en.MultipleApproversTemplate;
    },
    /**
    * en: My computer
    */
    get MyComputer() {
        return langMap[ep.resxCulture].MyComputer || langMap.en.MyComputer;
    },
    /**
    * en: Type message or drop files...
    */
    get NewMessageWatermark() {
        return langMap[ep.resxCulture].NewMessageWatermark || langMap.en.NewMessageWatermark;
    },
    /**
    * en: 1#{0} new post #{0} new posts
    */
    get NewPost() {
        return langMap[ep.resxCulture].NewPost || langMap.en.NewPost;
    },
    /**
    * en: No
    */
    get No() {
        return langMap[ep.resxCulture].No || langMap.en.No;
    },
    /**
    * en: Member is not found
    */
    get NoMatchRecipients() {
        return langMap[ep.resxCulture].NoMatchRecipients || langMap.en.NoMatchRecipients;
    },
    /**
    * en: Sorry, you haven't permission to edit this message
    */
    get NoPermissionToEditMessage() {
        return langMap[ep.resxCulture].NoPermissionToEditMessage || langMap.en.NoPermissionToEditMessage;
    },
    /**
    * en: Notification
    */
    get Notification() {
        return langMap[ep.resxCulture].Notification || langMap.en.Notification;
    },
    /**
    * en: Notify
    */
    get Notify() {
        return langMap[ep.resxCulture].Notify || langMap.en.Notify;
    },
    /**
    * en: Notify...
    */
    get NotifyLabel() {
        return langMap[ep.resxCulture].NotifyLabel || langMap.en.NotifyLabel;
    },
    /**
    * en: Non project members
    */
    get NotProjectMembers() {
        return langMap[ep.resxCulture].NotProjectMembers || langMap.en.NotProjectMembers;
    },
    /**
    * en: OneDrive
    */
    get OneDrive() {
        return langMap[ep.resxCulture].OneDrive || langMap.en.OneDrive;
    },
    /**
    * en: OneDrive File Picker
    */
    get OneDriveFilePicker() {
        return langMap[ep.resxCulture].OneDriveFilePicker || langMap.en.OneDriveFilePicker;
    },
    /**
    * en: Optimistic
    */
    get Optimistic() {
        return langMap[ep.resxCulture].Optimistic || langMap.en.Optimistic;
    },
    /**
    * en: or
    */
    get Or() {
        return langMap[ep.resxCulture].Or || langMap.en.Or;
    },
    /**
    * en: 1#approved#approved
    */
    get PluralApproved() {
        return langMap[ep.resxCulture].PluralApproved || langMap.en.PluralApproved;
    },
    /**
    * en: 1#{0} rejected#{0} rejected
    */
    get PluralRejected() {
        return langMap[ep.resxCulture].PluralRejected || langMap.en.PluralRejected;
    },
    /**
    * en: Post
    */
    get Post() {
        return langMap[ep.resxCulture].Post || langMap.en.Post;
    },
    /**
    * en: Post is waiting for approval
    */
    get PostWatingForApproval() {
        return langMap[ep.resxCulture].PostWatingForApproval || langMap.en.PostWatingForApproval;
    },
    /**
    * en: Preview images
    */
    get PreviewImages() {
        return langMap[ep.resxCulture].PreviewImages || langMap.en.PreviewImages;
    },
    /**
    * en: Professional
    */
    get Professional() {
        return langMap[ep.resxCulture].Professional || langMap.en.Professional;
    },
    /**
    * en: Project members
    */
    get ProjectMembers() {
        return langMap[ep.resxCulture].ProjectMembers || langMap.en.ProjectMembers;
    },
    /**
    * en: Reject
    */
    get Reject() {
        return langMap[ep.resxCulture].Reject || langMap.en.Reject;
    },
    /**
    * en: Replace
    */
    get Replace() {
        return langMap[ep.resxCulture].Replace || langMap.en.Replace;
    },
    /**
    * en: Request approval
    */
    get RequestApprovalLabel() {
        return langMap[ep.resxCulture].RequestApprovalLabel || langMap.en.RequestApprovalLabel;
    },
    /**
    * en: Retry
    */
    get Retry() {
        return langMap[ep.resxCulture].Retry || langMap.en.Retry;
    },
    /**
    * en: SharePoint
    */
    get SharePoint() {
        return langMap[ep.resxCulture].SharePoint || langMap.en.SharePoint;
    },
    /**
    * en: SharePoint File Picker
    */
    get SharePointFilePicker() {
        return langMap[ep.resxCulture].SharePointFilePicker || langMap.en.SharePointFilePicker;
    },
    /**
    * en: Show files
    */
    get ShowFiles() {
        return langMap[ep.resxCulture].ShowFiles || langMap.en.ShowFiles;
    },
    /**
    * en: Show previous
    */
    get ShowNext() {
        return langMap[ep.resxCulture].ShowNext || langMap.en.ShowNext;
    },
    /**
    * en: Approved by {0}
    */
    get SingleApprovedTemplate() {
        return langMap[ep.resxCulture].SingleApprovedTemplate || langMap.en.SingleApprovedTemplate;
    },
    /**
    * en: Approved by you.
    */
    get SingleApprovedTemplate_You() {
        return langMap[ep.resxCulture].SingleApprovedTemplate_You || langMap.en.SingleApprovedTemplate_You;
    },
    /**
    * en: Waiting for approval from {0}
    */
    get SingleApproverTemplate() {
        return langMap[ep.resxCulture].SingleApproverTemplate || langMap.en.SingleApproverTemplate;
    },
    /**
    * en: Rejected by {0}
    */
    get SingleRejectedTemplate() {
        return langMap[ep.resxCulture].SingleRejectedTemplate || langMap.en.SingleRejectedTemplate;
    },
    /**
    * en: Rejected by you.
    */
    get SingleRejectedTemplate_You() {
        return langMap[ep.resxCulture].SingleRejectedTemplate_You || langMap.en.SingleRejectedTemplate_You;
    },
    /**
    * en: Straightforward
    */
    get Straightforward() {
        return langMap[ep.resxCulture].Straightforward || langMap.en.Straightforward;
    },
    /**
    * en: Summarize
    */
    get Summarize() {
        return langMap[ep.resxCulture].Summarize || langMap.en.Summarize;
    },
    /**
    * en: Summarize into bullet points
    */
    get SummarizeBulletPoints() {
        return langMap[ep.resxCulture].SummarizeBulletPoints || langMap.en.SummarizeBulletPoints;
    },
    /**
    * en: Files
    */
    get TabFiles() {
        return langMap[ep.resxCulture].TabFiles || langMap.en.TabFiles;
    },
    /**
    * en: Messages
    */
    get TabMessages() {
        return langMap[ep.resxCulture].TabMessages || langMap.en.TabMessages;
    },
    /**
    * en: Teams
    */
    get Teams() {
        return langMap[ep.resxCulture].Teams || langMap.en.Teams;
    },
    /**
    * en: Undo
    */
    get Undo() {
        return langMap[ep.resxCulture].Undo || langMap.en.Undo;
    },
    /**
    * en:  by 
    */
    get UploadedBy() {
        return langMap[ep.resxCulture].UploadedBy || langMap.en.UploadedBy;
    },
    /**
    * en: Yes
    */
    get Yes() {
        return langMap[ep.resxCulture].Yes || langMap.en.Yes;
    },
    /**
    * en: You
    */
    get You() {
        return langMap[ep.resxCulture].You || langMap.en.You;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.messageBoard = messageBoardResx;
